import React from "react";

function AuthLayout({ children }) {
  return (
    <div className="container-fluid authentication-bg overflow-hidden">
      <div className="bg-overlay"></div>
      <div className="row align-items-center justify-content-center min-vh-100">
        <div className="col-10 col-md-10 col-lg-10 col-xxl-4">
          <div className="card mb-0">
            <div className="card-body">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AuthLayout;
